import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    carrerTouScroll: {
      height: '' //滚动的距离
    }
  },
  mutations: {
    setToken(state, data) {
      state.token = data
    },
    setCarrerTouScroll(state, disdance) { //管理赛事 滚动距离
      state.carrerTouScroll.height = disdance
    },
  },
  getters: {
    getCarrerTou: state => state.carrerTouScroll
  },
  actions: {},
  modules: {}
})